import { documentTypes } from "../types/documentTypes";
// import { userPermissionTypes } from "../types/userPermissionTypes";
import { Dispatch } from 'redux';
import { ThunkDispatch } from 'redux-thunk'
import { GET, POST, PUT, DELETE } from '../../utils/axios';
import moment from 'moment';
import { convertMilitaryDateToYMD } from "../../utils/global-functions";
import { POST_MULTIPART } from "../../utils/axios-multipart";
// import { maptoTruckDriverTable } from "../../scenes/TruckDriver/component/commonFn";

export const setDocumentSearchPayload = (payload: any) => ({
    type: documentTypes.DOCUMENT_SEARCH_PAYLOAD,
    payload
  });

  export const getDocumentData = (params: any) => {
    return async (dispatch: any) => {
      // dispatch({
      //   type: documentTypes.DOCUMENT_LOADING,
      //   payload: true
      // });
  
      try {
        const res = await documentDataApiReq(params);
  
        dispatch({
          type: documentTypes.DOCUMENT_DATA,
          payload: {
            data: res?.data?.lookupData || [],
            totalRows: res?.data?.totCount || 0
          }
        });
  
        return res;
      } catch (err) {
        dispatch({
          type: documentTypes.DOCUMENT_LOADING,
          payload: false
        });
        throw err;
      }
    };
  };
  
  export const documentDataApiReq = async (params: any) => {
    try {
      const res = await POST(`/orders/lookup/documents/${params.locationNumber}`, params);
      return res;
    } catch (err) {
      return {
        data: {
          lookupData: [],
          totalRows: 0
        }
      };
    }
  };
  

export const getDocumentTypeData = () => {
    return async (dispatch: Dispatch) => {
        const res = await documentTypeDataApiReq();
        dispatch(setDocumentType(res));
        return res;
    };
}

const setDocumentType = (apiData: any) => {
    return {
        type: documentTypes.DOCUMENT_TYPE_DATA,
        payload: apiData,
    };
};

export const documentTypeDataApiReq = async () => {
    try {
        let res = await GET(`/onbase/master/document-types`)

        if (res) {
            return res;
        }
        return [];
    } catch (err) {
        return [];
    }
};



// export const uploadDocuments = async (formData:any) => {
//   return POST_MULTIPART(
//     "/onbase/documents/upload",
//     formData
//   );
// };
export const uploadDocuments = async (
  locationNumber: string | number,
  formData: any
) => {
  return POST_MULTIPART(
    `/onbase/documents/upload/${locationNumber}`,
    formData
  );
};



export const sendEmail= async (locationNumber:number,mailData:any) => {
    try {
        let res = await POST(`/onbase/email/send-documents/${locationNumber}`,mailData)

        if (res) {
            return res;
        }
        return [];
    } catch (err) {
        return [];
    }
};

const setDocumentAuditData = (apiData: any) => {
    return {
        type: documentTypes.DOCUMENT_AUDIT_DATA,
        payload: apiData,
    };
};


export const  getDocumentAuditData = (params: any) => {
    return async (dispatch: Dispatch) => {
        console.log("params---new",params)
         const res = await getDocumentAuditDataReq(params);
         if (res?.httpCode===200) {
            const data= mapToDocumentAuditTable(res);
            console.log(".........data",data)
            dispatch(setDocumentAuditData(data));
            return data
         }else{
            dispatch(setDocumentAuditData([]));
            return res
         }
        
        // return res.data;
    }
}


export const mapToDocumentAuditTable = (res:any) => {
  try {
    const rows = res?.data?.documentAuditSummary?.map((item:any, index:number) => ({
      id: index,
      locationNumber: item?.locationNumber,
      control: item?.controlNumber,
      customerName: item?.customerName,

      billTo: item?.billTo,
      billToName: item?.billToName,

      billingDate: convertMilitaryDateToYMD(item?.billingDate) || "",
      returnDate: convertMilitaryDateToYMD(item?.returnDate) || "",
      apptDate: convertMilitaryDateToYMD(item?.apptDate) || "",

      apptTime: item?.apptTime,
      reference: item?.reference,
      unit: item?.unit,

      status: item?.status,
      transmitted: item?.transmitted,
      exceptionNote: item?.exceptionNote,

      orderType: item?.orderType,
      orderByEdi204: item?.orderByEdi204,
      totalStops: item?.totalStops,

      bolPodPopStatus: item?.bolPodPopStatus,

      // keep full documents array for rendering cells/icons
      documents: item?.documents || [],
      docColorStatus: item?.docColorStatus || []
    }));

    return {
      rows,
      totalRows: res?.data?.totalRows || 0
    };
  } catch (e) {
    console.error("Error occurred while mapping Document Audit data", e);
    return {
      rows: [],
      totalRows: 0
    };
  }
};

export const getDocumentAuditDataReq = async (params: any) => {

    console.log("params--sort",params)
    let url = `/onbase/document-audit`
    // const queryString = `?pageNumber=${params?.query?.page}&pageSize=${params?.query?.pageSize}&sortBy=${params?.sortData?.field}&sortOrder=${params?.sortData?.sort}`;
    const queryString = `?page=${params?.page}&size=${params?.pageSize}&sortOrder=${params?.sortOrder}&sortBy=${params?.sortBy}&dateType=${params?.dateType}&fromDate=${params?.dateRange[0]}&toDate=${params?.dateRange[1]}`
    // const queryString =""
    try {
        let res = await POST(url + queryString,{locationNumber:params.locationNumber});
        return res
    } catch (err) {
        console.error("API Error", err);
    return {
      rows: [],
      totalRows: 0
    }
}
   
}


export const updateAuditDocuments=  async (locationNumber: number,postData:any) => {
    try {
        let res = await PUT(`/orders/partial-bulk-update/${locationNumber}`,postData)

        if (res) {
            return res;
        }
        return [];
    } catch (err) {
        return [];
    }
   
}

export const reindexDocument = async (payload: any, locationNumber: number) => {
  return PUT(`/onbase/documents/reindex/${locationNumber}`, payload);
};

export const deleteDocument = async (locationNumber: number, documentId: number) => {
  return DELETE(`/onbase/documents/${locationNumber}/${documentId}`);
};